import React, { FC } from 'react';
import { Redirect } from 'react-router';
import features from '~/constants/features';
import paths from '../paths';

const Agent: FC<void> = () => {
  if (features.agent.leads.enabled) {
    return <Redirect to={paths.agent.leads} />;
  }
  return <Redirect to={paths.agent.applications} />;
};

export default Agent;
